import React, { useEffect, useState } from "react";
import { fetchCourseByCourseId } from "../../api/courseApi";
import { fetchCourseVideoById } from "../../api/courseVideoApi";
import Loading from "../common/Loading";
import { Link } from "react-router-dom";
import HtmlReader from "../common/HtmlReader";
import ToastService from "../../services/ToastService";
import { useSelector } from "react-redux";
import Modal3Js from "../Modal3Js";

const Lesson = ({ courseId, lessonId }) => {
  const user = useSelector((state) => state.user.user);
  const [dataCourseVideo, setDataCourseVideo] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchDataCourseVideo = async () => {
    try {
      const data = await fetchCourseVideoById({ courseVideoId: lessonId, userId: user && user.guid, });

      if (data) {
        setDataCourseVideo(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      setIsModalOpen(true)
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchDataCourseVideo();
  }, [lessonId]);

  return (
    <>
      {
        isModalOpen && <Modal3Js
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Thông báo"
          submitText="Confirm"
          cancelText="Cancel"
        >

          <p>Hãy <Link to={'/course/' + courseId} data-router-disabled="">mua khóa học này</Link> hoặc <Link to={'/pricing'} data-router-disabled="">nâng cấp</Link> lên gói Gold hoặc Diamond để xem video này!
          </p>
          <p>Nếu chưa có tiền trong tài khoản, <Link to={'/account/mywallet'} data-router-disabled="">bấm vào đây</Link> để nạp tiền vào tài khoản.
          </p>


          <div className="buttons">

            {/* <Link to="/account/addmoney" data-router-disabled="" className="button is-purple">
                <span className="hover"></span>
                <span className="label">


                  Nạp tiền


                </span>
              </Link> */}

            <button className="js-close button" onClick={() => {
              setIsModalOpen(false)
            }}>
              <span className="hover"></span>
              <span className="label">
                Đóng
              </span>
            </button>

          </div>
        </Modal3Js>
      }
      {dataCourseVideo && (
        <>

          <div className="js-player-top player-top">
            <section className="all-challenges js-all-challenges">
              <div
                className="video"
                style={{
                  textAlign: "center",
                  position: "relative",
                  width: "80%",
                  margin: "auto",
                }}
              >
                <iframe
                  title="1xx"
                  width="100%"
                  height={600}
                  src={
                    "https://drive.google.com/file/d/" +
                    dataCourseVideo.driverId +
                    "/preview"
                  }
                  frameborder="0"
                  allowFullScreen
                  style={{ borderRadius: "10px", position: "relative" }}
                ></iframe>
                {dataCourseVideo.videoType.includes("mp4") ? (
                  <div
                    style={{
                      width: "100%",
                      height: "60px",
                      position: "absolute",
                      opacity: 1,
                      right: "0px",
                      top: "0px",
                      backgroundColor: "black",
                    }}
                  >
                    &nbsp;
                  </div>
                ) : (
                  <div
                    style={{
                      width: "5%",
                      height: "60px",
                      position: "absolute",
                      opacity: 1,
                      right: "0px",
                      top: "0px",
                      borderRadius: "10px",
                      backgroundColor: "black",
                    }}
                  >
                    &nbsp;
                  </div>
                )}
              </div>
            </section>
          </div>
          <div className="js-lesson-content content width-1792">
            <header className="details">
              <div className="side informations">
                {/* <div className="sibling is-previous">
                  <a
                    className="sibling-link"
                    href="https://threejs-journey.com/lessons/first-threejs-project"
                    data-router-set=""
                  >
                    <div className="sibling-info">
                      <div className="sibling-label">03.</div>
                      <div className="sibling-title">
                        First Three.js Project
                      </div>
                    </div>
                    <span className="arrow">
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.5 7C5.10218 7 4.72064 6.84197 4.43934 6.56066L0.439339 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.439339 0.43934C1.02513 -0.146446 1.97487 -0.146446 2.56066 0.43934L5.5 3.37868L8.43934 0.43934C9.02513 -0.146447 9.97487 -0.146447 10.5607 0.439339C11.1464 1.02513 11.1464 1.97487 10.5607 2.56066L6.56066 6.56066C6.27936 6.84197 5.89782 7 5.5 7Z"
                          fill="white"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </div> */}
                <div className="current-lesson">
                  {/* <div className="label">{dataCourseVideo.order}.</div> */}
                  <h2 className="title">{dataCourseVideo.title}</h2>
                  {/* <p className="difficulty">
                    Difficulty <span className="value">Medium</span>
                  </p> */}
                </div>
                {/* <div className="sibling is-next">
                  <a
                    className="sibling-link"
                    href="https://threejs-journey.com/lessons/animations"
                    data-router-set=""
                  >
                    <div className="sibling-info">
                      <div className="sibling-label">05.</div>
                      <div className="sibling-title">Animations</div>
                    </div>
                    <span className="arrow">
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.5 7C5.10218 7 4.72064 6.84197 4.43934 6.56066L0.439339 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.439339 0.43934C1.02513 -0.146446 1.97487 -0.146446 2.56066 0.43934L5.5 3.37868L8.43934 0.43934C9.02513 -0.146447 9.97487 -0.146447 10.5607 0.439339C11.1464 1.02513 11.1464 1.97487 10.5607 2.56066L6.56066 6.56066C6.27936 6.84197 5.89782 7 5.5 7Z"
                          fill="white"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </div> */}
              </div>
              <div className="side aside">
                <div className="aside-section files">
                  <div className="title">
                    <span className="icon">
                      <svg
                        version="1.1"
                        id="Calque_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 15 18"
                      >
                        <path
                          className="st0"
                          d="M13.5,18h-12C0.7,18,0,17.3,0,16.5S0.7,15,1.5,15h12c0.8,0,1.5,0.7,1.5,1.5S14.3,18,13.5,18z"
                        ></path>
                        <path
                          className="st0"
                          d="M13.7,8.6c-0.5-0.7-1.4-0.8-2.1-0.4L9,10.1V1.5C9,0.7,8.3,0,7.5,0S6,0.7,6,1.5v8.6L3.4,8.3C2.7,7.8,1.7,8,1.3,8.6C0.8,9.3,1,10.3,1.6,10.7l5.9,4.1l5.9-4.1C14,10.3,14.2,9.3,13.7,8.6z"
                        ></path>
                      </svg>
                    </span>
                    <span className="label">Downloads</span>
                    {/* <button
                      className="js-popin-trigger info-button is-link"
                      data-popin-name="popin-how-to"
                    >
                      <span className="icon">
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17ZM9.75287 12.4921L9.87931 11.9206C9.81418 11.9545 9.70881 11.9947 9.56322 12.0413C9.41762 12.0836 9.28736 12.1048 9.17241 12.1048C8.9272 12.1048 8.75479 12.0603 8.65517 11.9714C8.55556 11.8825 8.50575 11.7153 8.50575 11.4698C8.50575 11.3725 8.52107 11.2286 8.55172 11.0381C8.58238 10.8476 8.61686 10.6783 8.65517 10.5302L9.12644 8.68254C9.17241 8.51323 9.20306 8.32698 9.21839 8.12381C9.23755 7.92064 9.24713 7.77884 9.24713 7.69841C9.24713 7.30899 9.12261 6.99365 8.87356 6.75238C8.62835 6.50688 8.27778 6.38413 7.82184 6.38413C7.56897 6.38413 7.30077 6.43492 7.01724 6.53651C6.73372 6.63386 6.43678 6.75238 6.12644 6.89206L6 7.46349C6.09195 7.4254 6.20115 7.38519 6.32759 7.34286C6.45785 7.30053 6.58429 7.27937 6.7069 7.27937C6.95594 7.27937 7.12452 7.32593 7.21264 7.41905C7.30077 7.51217 7.34483 7.67725 7.34483 7.91429C7.34483 8.0455 7.3295 8.19153 7.29885 8.35238C7.27203 8.509 7.23755 8.67619 7.1954 8.85397L6.72414 10.7079C6.68199 10.9026 6.65134 11.0783 6.63218 11.2349C6.61303 11.3873 6.60345 11.5376 6.60345 11.6857C6.60345 12.0667 6.72989 12.382 6.98276 12.6317C7.23946 12.8772 7.5977 13 8.05747 13C8.35632 13 8.61877 12.9556 8.84483 12.8667C9.07088 12.782 9.37356 12.6571 9.75287 12.4921ZM9.66667 4.99365C9.88889 4.76508 10 4.48995 10 4.16825C10 3.84656 9.88889 3.57143 9.66667 3.34286C9.44828 3.11429 9.18391 3 8.87356 3C8.56322 3 8.29694 3.11429 8.07471 3.34286C7.85249 3.57143 7.74138 3.84656 7.74138 4.16825C7.74138 4.48995 7.85249 4.76508 8.07471 4.99365C8.29694 5.21799 8.56322 5.33016 8.87356 5.33016C9.18391 5.33016 9.44828 5.21799 9.66667 4.99365Z"
                            fill="white"
                          ></path>
                        </svg>
                      </span>
                      <span className="label">How to?</span>
                    </button> */}
                  </div>
                  <a
                    href="/assets/lessons/5/04-transform-objects.zip"
                    data-router-disabled=""
                    download=""
                    className="button starter"
                  >
                    <span className="hover"></span>
                    <span className="label">Starter pack</span>
                  </a>
                  <a
                    href="/assets/lessons/5/04-transform-objects-final.zip"
                    data-router-disabled=""
                    download=""
                    className="button final"
                  >
                    <span className="hover"></span>
                    <span className="label">Final project</span>
                  </a>
                </div>
              </div>{" "}
            </header>

            <section className="text js-text">
              {dataCourseVideo && (
                <HtmlReader html={dataCourseVideo.description} />
              )}
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default Lesson;
